export default __webpack_public_path__ + "static/media/end_game.577d781f.svg";